// extracted by mini-css-extract-plugin
module.exports = {"row":"c5da4","row__column":"d3a59","rowColumn":"d3a59"};